export const DEMO_NAMESPACE = "gps-demo-v1";
export const DEMO_MARKETING_MESSAGE =
  "You are exploring our live GPSController demo in guided read-only mode. Track vehicles, history, alerts, and reports freely. Want to grow faster? Partner with us to resell GPSController coins and licenses, earn on activations, and unlock device onboarding, user roles, drivers, billing, and full operational controls.";

const normalizeValue = (value) => String(value || "").trim().toLowerCase();

export const hasDemoNamespaceAttribute = (attributes = []) =>
  Array.isArray(attributes) &&
  attributes.some((attribute) => {
    const key = normalizeValue(attribute?.key || attribute?.name);
    const value = normalizeValue(attribute?.value || attribute?.fieldValue);
    return (
      (key === "demonamespace" || key === "demo_namespace") &&
      value === DEMO_NAMESPACE
    );
  });

export const isDemoAccountUser = (user) => {
  if (!user) return false;

  const email = normalizeValue(user.email);
  const username = normalizeValue(user.username);
  const uniqueId = normalizeValue(user.uniqueId || user.userId || user.id);

  return (
    email === "demo@gpsdemo.com" ||
    username === "demo" ||
    uniqueId === "demo-admin" ||
    hasDemoNamespaceAttribute(user.attributes)
  );
};

export const isDemoReadOnlyUser = (user) => {
  if (!user) return false;
  return user.demoReadOnly === true || isDemoAccountUser(user);
};

export const getDemoReadOnlyMessage = (user) =>
  user?.demoReadOnlyMessage || DEMO_MARKETING_MESSAGE;
